import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ChevronDoubleLeftIcon = forwardRef<SVGSVGElement, IconProps>(function ChevronDoubleLeftIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.01149 5.45863C8.14152 5.59637 8.14152 5.8197 8.01149 5.95744L5.13928 9L8.01149 12.0426C8.14152 12.1803 8.14152 12.4036 8.01149 12.5414C7.88146 12.6791 7.67064 12.6791 7.54061 12.5414L4.43295 9.2494C4.30292 9.11166 4.30292 8.88834 4.43295 8.7506L7.54061 5.45863C7.67064 5.32089 7.88146 5.32089 8.01149 5.45863Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24868 5.20738C8.5097 5.48388 8.5097 5.93218 8.24868 6.20869L5.61364 9L8.24868 11.7913C8.5097 12.0678 8.5097 12.5161 8.24868 12.7926C7.98765 13.0691 7.56445 13.0691 7.30343 12.7926L4.19577 9.50066C3.93474 9.22415 3.93474 8.77585 4.19577 8.49934L7.30343 5.20738C7.56445 4.93087 7.98765 4.93087 8.24868 5.20738ZM4.86482 8.79561L4.67188 9L4.86482 9.20438C4.78352 9.08218 4.78352 8.91782 4.86482 8.79561Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.567 5.45863C13.6971 5.59637 13.6971 5.8197 13.567 5.95744L10.6948 9L13.567 12.0426C13.6971 12.1803 13.6971 12.4036 13.567 12.5414C13.437 12.6791 13.2262 12.6791 13.0962 12.5414L9.98851 9.2494C9.85848 9.11166 9.85848 8.88834 9.98851 8.7506L13.0962 5.45863C13.2262 5.32089 13.437 5.32089 13.567 5.45863Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8042 5.20738C14.0653 5.48388 14.0653 5.93218 13.8042 6.20869L11.1692 9L13.8042 11.7913C14.0653 12.0678 14.0653 12.5161 13.8042 12.7926C13.5432 13.0691 13.12 13.0691 12.859 12.7926L9.75132 9.50066C9.4903 9.22415 9.4903 8.77585 9.75132 8.49934L12.859 5.20738C13.12 4.93087 13.5432 4.93087 13.8042 5.20738ZM10.4204 8.79561L10.2274 9L10.4204 9.20438C10.3391 9.08218 10.3391 8.91782 10.4204 8.79561Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
